<template>
  <div class="riepilogo">
    <div class="central-block">

      <div class="n-copie offset-xl-5 col-xl-14 offset-lg-3 col-lg-18 offset-md-1 col-md-22 offset-0 col-24" v-if="(buono.numBuono === '')">
        <div class="row row-custom">
          <el-input v-model="nCopie" class="col-md-3 col-sm-4 col-5 no-padding" :maxlength="((conf.modoTrasp === '2') ? 2 : 1)"></el-input>
          <span class="my-label offset-1 col-lg-8 col-md-9 col-sm-10 col-18 no-padding">{{ $t('riepilogo.copie') }}</span>
        </div>
        <span class="nota" v-if="conf.modoTrasp === '3'">
          {{'(' + $t('riepilogo.max') + ' ' + nMaxCopie + ' ' + $t('riepilogo.buoniAmmessiCamion') + ')'}}
        </span>
        <span class="nota" v-if="conf.modoTrasp === '2'">
          {{'(' + $t('riepilogo.max') + ' ' + nMaxCopie + ' ' + $t('riepilogo.buoniAmmessiVagoni') + ')'}}
        </span>
      </div>

      <div class="blocco offset-xl-5 col-xl-14 offset-lg-3 col-lg-18 offset-md-1 col-md-22 offset-0 col-24">
        <div class="testata col-24">{{ $t('riepilogo.riepilogo').toUpperCase() }}</div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.numConferma') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ conf.numConf }}</div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.dataConsegna') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ conf.datConsDa + ' - ' + conf.datConsA }}</div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.numDdt') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.numDdt }}</div>
        </div>
        <div class="riga no-padding row row-custom" v-if="saved.step_0.ifFir === '1'">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.FIR') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.fir_1 + ' ' + saved.step_0.fir_2 + ' ' + saved.step_0.fir_3 }}</div>
        </div>
        <div class="riga no-padding row row-custom" v-if="conf.modoTrasp === '2'">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.letVettura') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.letVettura }}</div>
        </div>
        <div class="riga no-padding row row-custom" v-if="conf.modoTrasp === '2'">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.dataLVettura') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.dataLVettura }}</div>
        </div>
        <div class="riga no-padding row row-custom" v-if="(saved.step_0.ordNave.numOrdNave !== '' && saved.step_0.ordNave.numOrdNave !== '00000')">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.ordNave') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.ordNave.numOrdNave }}</div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.localita') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.loc.desLoca }}</div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.subFor') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.subFor.desSubfor }}</div>
        </div>
        <div class="riga no-padding row row-custom" v-if="(form.country !== '3')">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.spedizioniere') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.spedizioniere.desSpediz }}</div>
        </div>
        <div class="riga no-padding row row-custom" v-if="(form.country !== '3')">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.nomeAutista') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.nomeAutista }}</div>
        </div>
        <div class="riga no-padding row row-custom" v-if="(conf.modoTrasp === '3')">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.targaMotrice') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.targaMotrice }}</div>
        </div>
        <div class="riga no-padding row row-custom" v-if="(conf.modoTrasp === '3')">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.targaRimorchio') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.targaRimorchio }}</div>
        </div>
        <div class="riga no-padding row row-custom" v-if="(conf.modoTrasp === '2')">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.numVagone') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.numVagone }}</div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.dataSpedizione') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.dataSpedizione }}</div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.dataArrivo') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">
            {{
              saved.step_0.dataArrivo +
              (saved.step_0.tmStr && saved.step_0.tmEnd
                ? (' (' + moment(saved.step_0.tmStr, 'YYYY-MM-DD-HH.mm.ss').format('HH:mm:ss') + ' - ' + moment(saved.step_0.tmEnd, 'YYYY-MM-DD-HH.mm.ss').format('HH:mm:ss') + ')')
                : ''
              )
            }}
          </div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.protocolliSicurezza') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">
            <el-checkbox class="custom-checkbox" v-model="checked" :disabled="true"></el-checkbox>
          </div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.prodotti') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">
            <div class="row row-custom" v-for="item in saved.step_2.prodotti" :key="item.codProd">
              <div class="col-16 no-padding">{{item.desProd}}</div>
              <div class="col-8 no-padding">{{item.qtaDic + ((item.qtaDic !== '') ? ' Kg' : '')}}</div>
            </div>
            <div class="row row-custom qtaTot">
              <div class="col-16 no-padding">{{ $t('riepilogo.totale').toUpperCase() }}</div>
              <div class="col-8 no-padding">{{saved.step_2.qtaTot + ((saved.step_2.qtaTot !== '') ? ' Kg' : '')}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="blocco offset-xl-5 col-xl-14 offset-lg-3 col-lg-18 offset-md-1 col-md-22 offset-0 col-24" v-if="(form.country === '3')">
        <div class="testata col-24">{{ $t('riepilogo.datiTrasportatore').toUpperCase() }}</div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.ragioneSociale') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.ifSpedizObblig ? saved.step_0.spedizioniere.desSpediz : saved.step_0.ragSocTrasp }}</div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.indirizzo') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.indirTrasp }}</div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.localita') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.localTrasp }}</div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.cap') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.capTrasp }}</div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.partitaIva') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.paIvaTrasp }}</div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.nomeAutista') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.nomeAutista }}</div>
        </div>
        <div class="riga no-padding row row-custom">
          <div class="my-label col-lg-7 col-md-8 col-sm-9 col-9">{{ $t('riepilogo.numeroPatente') }}</div>
          <div class="value col-lg-17 col-md-16 col-sm-15 col-15">{{ saved.step_0.nPatente }}</div>
        </div>
      </div>
    </div>

    <div class="button col-22 offset-1">
      <el-button class="custom-button" @click="back" :loading="ifLoading">{{$t('riepilogo.indietro').toUpperCase()}}</el-button>
      <el-button class="custom-button" type="primary" @click="salva" :loading="ifLoading">{{ $t('riepilogo.salva').toUpperCase() }}</el-button>
    </div>
  </div>
</template>

<script>
  import {bus} from '../../Bus'
  import moment from 'moment'

  export default {
    name: 'Riepilogo',
    props: ['saved', 'buono', 'buonoAttrib', 'buonoData', 'form', 'conf'],
    data () {
      return {
        codLang: sessionStorage.getItem('codLang'),
        checked: (this.saved.step_1.protSicur === 'S'),
        nCopie: 1,
        nMaxCopie: (this.conf.modoTrasp === '3') ? 9 : 21,
        ifLoading: false,
        moment: moment
      }
    },
    i18n: {
      messages: {
        it_IT: {
          riepilogo: {
            copie: 'Copie dello stesso buono',
            max: 'max',
            buoniAmmessiCamion: 'buoni ammessi per lo stesso camion',
            buoniAmmessiVagoni: 'buoni ammessi per lo stesso vagone',
            riepilogo: 'Riepilogo',
            numConferma: 'Nr. Conferma',
            dataConsegna: 'Data Consegna',
            numDdt: 'Numero DDT',
            ordNave: 'Ordine Nave',
            localita: 'Località',
            subFor: 'SubFornitore',
            spedizioniere: 'Spedizioniere',
            nomeAutista: 'Nome Autista',
            targaMotrice: 'Targa Motrice',
            targaRimorchio: 'Targa Rimorchio',
            numVagone: 'Numero Vagone',
            dataSpedizione: 'Data Spedizione',
            dataArrivo: 'Data Arrivo',
            protocolliSicurezza: 'Protocolli Sicurezza',
            prodotti: 'Prodotti',
            totale: 'Totale',
            elimina: 'Elimina',
            salva: 'Salva',
            indietro: 'Indietro',
            letVettura: 'Lettera Vettura',
            dataLVettura: 'Data Lettera Vettura',
            datiTrasportatore: 'Dati Trasportatore',
            ragioneSociale: 'Ragione Sociale',
            indirizzo: 'Indirizzo',
            cap: 'CAP',
            partitaIva: 'Partita IVA',
            numeroPatente: 'N. Patente Autista',
            FIR: 'FIR'
          }
        },
        fr_FR: {
          riepilogo: {
            copie: 'Copies du meme BDD',
            max: 'max',
            buoniAmmessiCamion: 'bdd autorisés puor la rotation da un seule véhicule',
            buoniAmmessiVagoni: 'bdd autorisés puor la rotation da un seule wagon',
            riepilogo: 'Résumé',
            numConferma: 'Nr. Commande',
            dataConsegna: 'Date Commande',
            numDdt: 'Votre Bon de Livraison',
            ordNave: 'Commande Navire',
            localita: 'Provenance',
            subFor: 'Sous Traitant',
            spedizioniere: 'Transporteur',
            nomeAutista: 'Nom du Chauffeur',
            targaMotrice: 'Immatric. Tracteur',
            targaRimorchio: 'Immatric. Remorque',
            numVagone: 'Numéro Wagon',
            dataSpedizione: 'Date d\'Expedition',
            dataArrivo: 'Date arrivée',
            protocolliSicurezza: 'Protocoles de sécurité',
            prodotti: 'Produits',
            totale: 'Total',
            elimina: 'Supprimer',
            salva: 'Valider',
            indietro: 'Precedent',
            letVettura: 'Lettre de voiture',
            dataLVettura: 'Lettre de voiture date',
            datiTrasportatore: 'Données du Convoyeur',
            ragioneSociale: 'Nom de l\'Entreprise',
            indirizzo: 'Adresse',
            cap: 'CAP',
            partitaIva: 'Numéro de TVA',
            numeroPatente: 'N. Permis de Conduire',
            FIR: 'FIR'
          }
        },
        es_ES: {
          riepilogo: {
            copie: 'Copias del mismo vale',
            max: 'max',
            buoniAmmessiCamion: 'viajes autorizados para el mismo camión',
            buoniAmmessiVagoni: 'viajes autorizados para el mismo vagón',
            riepilogo: 'Resumen',
            numConferma: 'Nr. de Pedido',
            dataConsegna: 'Dìa de Entrega',
            numDdt: 'Numero DDT',
            ordNave: 'Contrato Barco',
            localita: 'Localidad',
            subFor: 'Subproveedor',
            spedizioniere: 'Transpostista',
            nomeAutista: 'Nombre Conductor',
            targaMotrice: 'Matricula Cabeza',
            targaRimorchio: 'Matricula Remolque',
            numVagone: 'Número de vagón',
            dataSpedizione: 'Día de salida',
            dataArrivo: 'Día llegada',
            protocolliSicurezza: 'Protocolos de seguridad',
            prodotti: 'Productos',
            totale: 'Total',
            elimina: 'Eliminar',
            salva: 'Guardar',
            indietro: 'Atrás',
            letVettura: 'Hoja de ruta',
            dataLVettura: 'Fecha Hoja de ruta',
            datiTrasportatore: 'Datos del Transportista',
            ragioneSociale: 'Transportista',
            indirizzo: 'Dirección',
            cap: 'Código Postal',
            partitaIva: 'NIF/CIF',
            numeroPatente: 'N. Carnet Conducir',
            FIR: 'FIR'
          }
        },
        de_DE: {
          riepilogo: {
            copie: 'Kopien für denselben schein',
            max: 'max',
            buoniAmmessiCamion: 'zulässige scheine für denselben LKW',
            buoniAmmessiVagoni: 'zulässige scheine für denselben Waggon',
            riepilogo: 'Zusammenfassung',
            numConferma: 'Vertrag',
            dataConsegna: 'Lieferzeitraum',
            numDdt: 'Lieferschein Nr.',
            ordNave: 'Schiffsnummer',
            localita: 'Herkunft',
            subFor: 'Subunternehmer',
            spedizioniere: 'Spediteur',
            nomeAutista: 'Fahrer',
            targaMotrice: 'Kennzeichen LKW',
            targaRimorchio: 'Auflieger',
            numVagone: 'Anzahl Wagen',
            dataSpedizione: 'Versanddatum',
            dataArrivo: 'Ankunfts',
            protocolliSicurezza: 'Sicherheitsprotokolle',
            prodotti: 'Produkte',
            totale: 'Gesamt',
            elimina: 'Löschen',
            salva: 'Speichern',
            indietro: 'Zurück',
            letVettura: 'Auto Brief',
            dataLVettura: 'Auto Brief Datum',
            datiTrasportatore: 'Förderdaten',
            ragioneSociale: 'Firmenname',
            indirizzo: 'Adresse',
            cap: 'Postleitzahl',
            partitaIva: 'Umsatzsteuer-Id.',
            numeroPatente: 'Führerscheinnummer',
            FIR: 'FIR'
          }
        },
        en_GB: {
          riepilogo: {
            copie: 'Copies of the same pass',
            max: 'max',
            buoniAmmessiCamion: 'passes accepted for the same truck',
            buoniAmmessiVagoni: 'passes accepted for the same wagon',
            riepilogo: 'Summary',
            numConferma: 'Confirm. Nr.',
            dataConsegna: 'Delivery Date',
            numDdt: 'DDT Number',
            ordNave: 'Order Ship',
            localita: 'Place',
            subFor: 'SubContractor',
            spedizioniere: 'Forwarder',
            nomeAutista: 'Driver Name',
            targaMotrice: 'Driving plate',
            targaRimorchio: 'Trailer plate',
            numVagone: 'Wagon Number',
            dataSpedizione: 'Shipping Date',
            dataArrivo: 'Arrival Date',
            protocolliSicurezza: 'Security protocols',
            prodotti: 'Products',
            totale: 'Total',
            elimina: 'Elimina',
            salva: 'Salva',
            indietro: 'Back',
            letVettura: 'Car Letter',
            dataLVettura: 'Car Letter Date',
            datiTrasportatore: 'Conveyor data',
            ragioneSociale: 'Business Name',
            indirizzo: 'Address',
            cap: 'Postal Code',
            partitaIva: 'VAT number',
            numeroPatente: 'Driver\'s License N.',
            FIR: 'FIR'
          }
        }
      }
    },
    methods: {
      back: function () {
        this.$emit('indietro')
      },
      salva: function () {
        this.$set(this, 'ifLoading', true)
        let arrayProdotti = this.saved.step_2.prodotti.filter(item => item.qtaDic).map(item => {
          let { codiciCER, ...rest } = item
          return rest
        })
        let payload = {
          codLang: this.codLang,
          codForn: this.form.fornitore.codForn,
          tipoForn: this.form.fornitore.tipForn,
          mail: sessionStorage.getItem('mailFornitore'),
          country: this.form.country,
          codSoc: this.form.stab.codSoc,
          codStab: this.form.stab.codStab,
          numConf: this.conf.numConf,
          numBuono: this.buono.numBuono,
          datConsDa: this.conf.datConsDa,
          datConsA: this.conf.datConsA,
          qtaTot: this.saved.step_2.qtaTot,
          codSubfor: (this.saved.step_0.subFor.codSubfor !== undefined) ? this.saved.step_0.subFor.codSubfor : '',
          desSubfor: (this.saved.step_0.subFor.desSubfor !== undefined) ? this.saved.step_0.subFor.desSubfor : '',
          codLocalita: this.saved.step_0.loc.codLoca,
          desLocalita: this.saved.step_0.loc.desLoca,
          poiSO: this.saved.step_0.loc.poiSO,
          poiPR: this.saved.step_0.loc.poiPR,
          targaMot: this.saved.step_0.targaMotrice,
          targaRim: this.saved.step_0.targaRimorchio,
          nomeAutista: this.saved.step_0.nomeAutista,
          datSped: this.saved.step_0.dataSpedizione,
          datArrivo: this.saved.step_0.dataArrivo,
          numDdt: this.saved.step_0.numDdt,
          letVettura: this.saved.step_0.letVettura,
          dataLVettura: this.saved.step_0.dataLVettura,
          codSpediz: (this.saved.step_0.UNI_TRASP_ROT !== 'Y' && this.saved.step_0.spedizioniere.codSpediz) ? this.saved.step_0.spedizioniere.codSpediz : '',
          desSpediz: (this.saved.step_0.spedizioniere.desSpediz) ? this.saved.step_0.spedizioniere.desSpediz : '',
          codTRS: (this.saved.step_0.UNI_TRASP_ROT === 'Y' && this.saved.step_0.spedizioniere.codTRS) ? this.saved.step_0.spedizioniere.codTRS : '',
          numOrdNave: (this.saved.step_0.ordNave.numOrdNave !== undefined) ? this.saved.step_0.ordNave.numOrdNave : '',
          annoOrdNave: (this.saved.step_0.ordNave.annoOrdNave !== undefined) ? this.saved.step_0.ordNave.annoOrdNave : '',
          protSicur: this.saved.step_1.protSicur,
          multiSave: this.nCopie,
          modoTrasp: this.conf.modoTrasp,
          numVagone: this.saved.step_0.numVagone,
          prodotti: arrayProdotti,
          ragSocTrasp: this.saved.step_0.ragSocTrasp,
          indirTrasp: this.saved.step_0.indirTrasp,
          capTrasp: this.saved.step_0.capTrasp,
          localTrasp: this.saved.step_0.localTrasp,
          paIvaTrasp: this.saved.step_0.paIvaTrasp,
          nPatente: this.saved.step_0.nPatente,
          fir: this.saved.step_0.fir_1 + ' ' + this.saved.step_0.fir_2 + ' ' + this.saved.step_0.fir_3,
          tmStr: this.saved.step_0.tmStr,
          tmEnd: this.saved.step_0.tmEnd,
          gate: '', // Sempre vuoto per ROT
          codTsl: this.saved.step_0.codTsl,
          channel: this.saved.step_0.channel,
          ifRifiuto: this.saved.step_2.ifRifiuto
        }
        this.$http.put('buonidiscarico/buono', payload)
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                message: response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
              this.$router.push({name: 'GestioneRottameElencoBuoni'})
              this.$nextTick(() => {
                bus.$emit('WebGestioneRottame-Ricerca')
              })
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'ifLoading', false)
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: 'Internal server error',
              type: 'error',
              duration: process.env.duration
            })
            this.$set(this, 'ifLoading', false)
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .riepilogo {
    .central-block {
      .n-copie {
        margin-bottom: 20px;
        .my-label {
          margin-left: 15px;
          line-height: 23px;
        }
        .el-input {
          .el-input__inner {
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-bottom: 5px;
            height: 20px;
            border-radius: 0px;
            .set-font(@size: 12px);
          }
        }
        .nota {
          .set-font(@size: 12px);
        }
      }
      .blocco {
        margin-bottom: 15px;
        text-align: center;
        .testata {
          background-color: #eae5e5;
          height: 30px;
          border: 1px solid #cccccc;
          color: #007c74;
          line-height: 30px;
          font-weight: bold;
          font-size: 16px;
        }
        .riga {
          text-align: left;
          border: 1px solid #cccccc;
          border-top: none;
          .my-label {
            line-height: 25px;
            overflow: hidden;
            text-overflow: ellipsis;
            text-transform: uppercase;
            letter-spacing: 1px;
            .set-font(@size: 11px, @color: @greenRiva, @family: 'os-semibold');
          }
          .value {
            line-height: 25px;
            .set-font(@size: 12px, @color: @textTable, @family: 'os-regular');
            letter-spacing: 1px;
            .custom-checkbox {
              margin-bottom: 0px;
              padding: 0;
            }
            .qtaTot {
              border-top: 1px solid #ccc;
            }
          }
        }
      }
    }
    .button {
      margin-top: 40px;
      text-align: right;
      margin-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebGestioneRottame/Riepilogo.vue